import { render } from "./MonsterPlayer.vue?vue&type=template&id=3ae580a2&scoped=true"
import script from "./MonsterPlayer.vue?vue&type=script&lang=js"
export * from "./MonsterPlayer.vue?vue&type=script&lang=js"

import "./MonsterPlayer.vue?vue&type=style&index=0&id=3ae580a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\winni\\Desktop\\網頁設計\\作品\\怪獸遊戲\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae580a2"]])

export default __exports__